<template>
  <va-create-layout>
    <pathologies-form :title="title" :item="item"></pathologies-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
